// src/node_modules/@awesome.me/kit-63db24046b/icons/modules/kit/custom.mjs
var faNextjs = {
  prefix: "fak",
  iconName: "nextjs",
  icon: [
    512,
    512,
    [],
    "e011",
    "M239.2 .1c-1.1 .1-4.6 .5-7.8 .7-72.7 6.6-140.8 45.8-184 106.1-24 33.5-39.4 71.6-45.2 111.8-2.1 14.1-2.3 18.2-2.3 37.3s.3 23.2 2.3 37.3c13.9 96.1 82.3 176.9 175.1 206.8 16.6 5.4 34.1 9 54.1 11.2 7.8 .9 41.3 .9 49 0 34.4-3.8 63.5-12.3 92.2-27 4.4-2.3 5.3-2.9 4.7-3.4-.4-.3-19.2-25.5-41.7-55.9l-40.9-55.3-51.3-75.9c-28.2-41.7-51.5-75.9-51.7-75.9-.2-.1-.4 33.7-.5 74.9-.2 72.1-.2 75-1.1 76.7-1.3 2.5-2.3 3.5-4.4 4.6-1.6 .8-3 1-10.6 1l-8.7 0-2.3-1.5c-1.5-1-2.6-2.2-3.4-3.7l-1.1-2.3 .1-100.3 .2-100.4 1.6-2c.8-1.1 2.5-2.4 3.7-3.1 2.1-1 2.9-1.1 11.5-1.1 10.2 0 11.9 .4 14.6 3.3 .8 .8 28.5 42.6 61.8 93s78.7 119.2 101 153l40.5 61.4 2.1-1.4c18.2-11.8 37.4-28.6 52.6-46.1 32.4-37.2 53.3-82.5 60.3-130.9 2.1-14.1 2.3-18.2 2.3-37.3s-.3-23.2-2.3-37.3c-13.9-96.1-82.3-176.9-175.1-206.8-16.4-5.3-33.8-9-53.3-11.2-4.8-.5-37.9-1.1-42-.7l0 0zM344 155c2.4 1.2 4.4 3.5 5.1 5.9 .4 1.3 .5 29.1 .4 91.8l-.2 90-15.9-24.3-15.9-24.3 0-65.4c0-42.3 .2-66.1 .5-67.2 .8-2.8 2.6-5 5-6.3 2.1-1.1 2.8-1.2 10.7-1.2 7.4 0 8.7 .1 10.4 1z"
  ]
};
export {
  faNextjs
};
